<button class="border-0 rounded-full"
  mat-stroked-button
  matTooltip="{{'shared:help' | translate}}"
  (click)="open = true">
  <i class="fa-regular fa-lightbulb mr-2"></i>
  {{ 'shared:help' | translate }}
</button>

<ew-sidebar
  [open]="open"
  [title]="'shared:help'"
  (close)="open = false">

  <iframe 
    [src]="src" 
    style="border:0px #ffffff none;" 
    scrolling="yes" 
    frameborder="1" 
    marginheight="0px" 
    marginwidth="0px" 
    height="100%" 
    width="100%" 
    allowfullscreen
  ></iframe>
</ew-sidebar>
